import { Sparkles } from 'lucide-react';

/**
 * Demo Profile badge — shown next to seeded/sample profiles so users (and the
 * App Store reviewers) know the profile is starter/sample data, not a real
 * person. Required for App Store compliance (no deceptive practices).
 *
 * Usage: <DemoProfileBadge isSeed={profile.is_seed} />
 */
export default function DemoProfileBadge({ isSeed, size = 'md', className = '' }) {
  if (!isSeed) return null;
  const sizes = {
    xs: 'text-[9px] px-1.5 py-0.5 gap-0.5',
    sm: 'text-[10px] px-2 py-0.5 gap-1',
    md: 'text-[11px] px-2 py-[3px] gap-1',
  };
  const iconSize = size === 'xs' ? 8 : size === 'sm' ? 9 : 10;
  return (
    <span
      data-testid="demo-profile-badge"
      title="This is a sample/demo profile, not a real user"
      className={`inline-flex items-center font-semibold rounded-full uppercase tracking-wider bg-amber-50 text-amber-800 border border-amber-300/70 ${sizes[size]} ${className}`}
    >
      <Sparkles size={iconSize} className="text-amber-600" />
      Demo Profile
    </span>
  );
}
